//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PriceCurrent from './PriceCurrent'
import PriceOriginal from './PriceOriginal'

export default {
  components: {
    PriceCurrent,
    PriceOriginal,
  },
  props: {
    /**
     * Backmarket's price
     *
     * @typedef {object} originalPrice
     * @property {number} price.raw
     * @property {string} price.display
     */
    price: {
      type: Object,
      default: () => ({}),
    },
    /**
     * Before Backmarket's price
     *
     * @typedef {object} originalPrice
     * @property {number} originalPrice.raw
     * @property {string} originalPrice.display
     */
    originalPrice: {
      type: Object,
      default: () => ({}),
    },
    size: {
      type: String,
      default: 'small',
      validator: (value) => ['small', 'medium', 'large'].includes(value),
    },
    color: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'secondary', 'white'].includes(value),
    },
  },
  computed: {
    isDisplayedOriginalPrice() {
      return this.price.raw < this.originalPrice.raw
    },
  },
}
